<template>
  <div>
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="showDialog"
      @close="setDialogClosed" append-to-body>
      <el-container class="container" direction="vertical" style="height: 500px">
        <ul style="overflow: auto; margin-right: 20px">
          <el-descriptions :column="4" border style="margin-bottom: 10px">
            <el-descriptions-item :span="2" label="编号">
              {{ detail.healthNo }}
            </el-descriptions-item>

            <el-descriptions-item :span="2" label="姓名">
              {{ detail.patientName }}
            </el-descriptions-item>

            <el-descriptions-item span="2" label="电话">
              {{ detail.phone }}
            </el-descriptions-item>

            <el-descriptions-item span="2" label="身份证号">
              {{ detail.idcard }}
            </el-descriptions-item>

            <el-descriptions-item span="2" label="住址">
              {{ detail.address }}
            </el-descriptions-item>

            <el-descriptions-item span="2" label="联系人">
              {{ detail.contactName }}
            </el-descriptions-item>

            <el-descriptions-item span="2" label="联系人电话">
              {{ detail.contactPhone }}
            </el-descriptions-item>

            <el-descriptions-item span="4" label="症状">
              <el-checkbox-group v-model="detail.content.symptoms" disabled>
                <el-checkbox v-for="item in symptomList" :label="item" :key="item">{{ item }}</el-checkbox>
              </el-checkbox-group>
            </el-descriptions-item>

            <el-descriptions-item span="4" label="体征">
              <el-descriptions :column="4" border>
                <el-descriptions-item span="2" label="空腹血糖值(mmol/L)">
                  {{ detail.content.emptyGlu }}
                </el-descriptions-item>

                <el-descriptions-item span="2" label="餐后血糖值(mmol/L)">
                  {{ detail.content.twohourGlu }}
                </el-descriptions-item>

                <el-descriptions-item span="2" label="随机血糖值(mmol/L)">
                  {{ detail.content.randomGlu }}
                </el-descriptions-item>

                <el-descriptions-item span="2" label="身高(cm)">
                  {{ detail.content.height }}
                </el-descriptions-item>

                <el-descriptions-item span="2" label="血压(mmHg)">
                  {{ detail.content.sbp }}/{{ detail.content.dbp }}
                </el-descriptions-item>

                <el-descriptions-item span="2" label="体重(kg)">
                  {{ detail.content.weight }}
                </el-descriptions-item>


                <el-descriptions-item span="2" label="体质指数(kg/㎡)">
                  {{ detail.content.bmi }}
                </el-descriptions-item>


                <el-descriptions-item span="2" label="足背动脉搏动">
                  {{ detail.content.dorsalisPedisPulse }}
                </el-descriptions-item>

                <el-descriptions-item span="2" label="腰围(cm)">
                  {{ detail.content.waist }}
                </el-descriptions-item>
              </el-descriptions>
            </el-descriptions-item>

            <el-descriptions-item span="4" label="生活方式指导">
              <el-descriptions :column="1" border>
                <el-descriptions-item span="4" label="日吸烟量(支/天)">
                  {{ detail.content.smokePerday }}
                </el-descriptions-item>

                <el-descriptions-item span="4" label="日饮酒量(两)">
                  {{ detail.content.drinkPerday }}
                </el-descriptions-item>

                <el-descriptions-item span="4" label="日吸烟量指导(支/天)">
                  {{ detail.content.smokePerdayTarget }}
                </el-descriptions-item>

                <el-descriptions-item span="4" label="日饮酒量指导">
                  <el-descriptions :colums="4" border>
                    <el-descriptions-item span="4" label="饮酒品类">
                      {{ detail.content.drinkType }}
                    </el-descriptions-item>

                    <el-descriptions-item style="display: flex;" span="4" label="饮酒量">
                      {{ detail.content.drinkPerdayTarget }}{{ detail.content.drinkUnit }}
                    </el-descriptions-item>
                  </el-descriptions>
                </el-descriptions-item>

                <el-descriptions-item :span="4" label="运动基本情况">
                  <el-descriptions :colums="4" border>
                    <el-descriptions-item span="2" label="运动频次(次/周)">
                      {{ detail.content.sportFreq }}
                    </el-descriptions-item>

                    <el-descriptions-item span="2" label="运动时长(分钟/次)">
                      {{ detail.content.sportMinutesPertime }}
                    </el-descriptions-item>

                    <el-descriptions-item span="2" label="运动时是否有胸闷、胸痛不适感">
                      {{ detail.content.sportTired }}
                    </el-descriptions-item>

                    <el-descriptions-item span="2" label="运动过程中是否有过跌倒情况">
                      {{ detail.content.sportFall }}
                    </el-descriptions-item>

                    <el-descriptions-item span="2" label="运动过程中是否有低血糖情况">
                      {{ detail.content.sportBloodsugar }}
                    </el-descriptions-item>

                    <el-descriptions-item span="2" label="是否存在足底破溃">
                      {{ detail.content.sportFoot }}
                    </el-descriptions-item>
                  </el-descriptions>
                </el-descriptions-item>

                <el-descriptions-item :span="4" label="运动行为指导">
                  <el-descriptions :colums="4" border>
                    <el-descriptions-item span="2" label="运动时间">
                      {{ detail.content.sportPeriodGuides }}
                    </el-descriptions-item>
                    <el-descriptions-item span="2" label="运动时长">
                      {{ detail.content.sportMinutesPertimeTarget }}
                    </el-descriptions-item>
                    <el-descriptions-item span="2" label="运动频次">
                      {{ detail.content.sportFreqTarget }}
                    </el-descriptions-item>
                  </el-descriptions>
                </el-descriptions-item>
                <el-descriptions-item span="4" label="饮食习惯">
                  <el-descriptions :colums="4" border>
                    <el-descriptions-item span="4" label="您是否了解饮食与血糖的影响">
                      {{ detail.content.knowDietSugar }}
                    </el-descriptions-item>

                    <el-descriptions-item span="4" label="您是否执行过糖尿病饮食">
                      {{ detail.content.obeyDiabetesDiet }}
                    </el-descriptions-item>

                    <el-descriptions-item span="4" label="您的三餐是否有规律">
                      {{ detail.content.dietRegular }}
                    </el-descriptions-item>

                    <el-descriptions-item span="4" label="您的口味偏好">
                      {{ detail.content.taste }}
                    </el-descriptions-item>

                    <el-descriptions-item span="4" label="您的饮食嗜好">
                      {{ detail.content.dietHobbies }}
                    </el-descriptions-item>
                  </el-descriptions>
                </el-descriptions-item>

                <el-descriptions-item span="4" label="饮食指导">
                  {{ detail.content.dietGuide }}
                </el-descriptions-item>
              </el-descriptions>
            </el-descriptions-item>

            <el-descriptions-item span="4" label="用药指导">
              <el-descriptions :column="4" border>
                <el-descriptions-item span="4" label="基本情况">
                  <el-descriptions :column="4" border>
                    <el-descriptions-item span="4" label="服药依从性">
                      {{ detail.content.medicationAdherence }}
                    </el-descriptions-item>

                    <el-descriptions-item span="4" label="药物不良反应">
                      {{ detail.content.medicationBadEvent }}
                    </el-descriptions-item>

                    <el-descriptions-item span="4" label="是否有药物过敏史">
                      {{ detail.content.allergy }}
                    </el-descriptions-item>

                    <el-descriptions-item span="4" label="低血糖反应">
                      {{ detail.content.hypoglycemiaReaction }}
                    </el-descriptions-item>
                  </el-descriptions>
                </el-descriptions-item>


                <el-descriptions-item span="4" label="目前用药情况">
                  <el-descriptions :column="1" border>
                    <el-descriptions-item class="medicines" label="用药" v-for="(item, index) in detail.content.medicines" :key="index">
                      <el-descriptions :column="4" border>
                        <el-descriptions-item span="2" label="药物名称">
                          {{ item.medicineName }}
                        </el-descriptions-item>
                        <el-descriptions-item span="2" label="用药次数/日">
                          {{ item.freq }}
                        </el-descriptions-item>
                        <el-descriptions-item span="2" label="用量/次">
                          {{ item.dosage }}
                        </el-descriptions-item>
                        <el-descriptions-item span="2" label="用药时间">
                          {{ item.takeMethod }}
                        </el-descriptions-item>
                        <el-descriptions-item span="4" label="注意事项">
                          {{ item.remark }}
                        </el-descriptions-item>
                      </el-descriptions>
                    </el-descriptions-item>
                  </el-descriptions>
                </el-descriptions-item>

                <el-descriptions-item span="4" label="用药调整指导">
                  <el-descriptions :column="1" border>
                    <el-descriptions-item class="medicines" label="用药" v-for="(item, index) in detail.content.medicinesGuide" :key="index">
                      <el-descriptions :column="4" border>
                        <el-descriptions-item span="2" label="药物名称">
                          {{ item.medicineName }}
                        </el-descriptions-item>
                        <el-descriptions-item span="2" label="用药次数/日">
                          {{ item.freq }}
                        </el-descriptions-item>
                        <el-descriptions-item span="2" label="用量/次">
                          {{ item.dosage }}
                        </el-descriptions-item>
                        <el-descriptions-item span="2" label="用药时间">
                          {{ item.takeMethod }}
                        </el-descriptions-item>
                        <el-descriptions-item span="4" label="注意事项">
                          {{ item.remark }}
                        </el-descriptions-item>
                      </el-descriptions>
                    </el-descriptions-item>
                  </el-descriptions>
                </el-descriptions-item>
              </el-descriptions>
            </el-descriptions-item>

            <el-descriptions-item span="4" label="随访人">
              {{ detail.content.doctorName }}
            </el-descriptions-item>

            <el-descriptions-item span="4" label="本次随访时间">
              {{ detail.content.followupTime }}
            </el-descriptions-item>

            <el-descriptions-item span="4" label="下次随访时间">
              {{ detail.content.nextFollowupTime }}
            </el-descriptions-item>
          </el-descriptions>
        </ul>
      </el-container>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="showDialog = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      symptomList: ["多饮", "多食", "多尿", "视力模糊", "感染", "手脚麻木", "下肢浮肿", "体重明显下降", "关节疼痛"],
      showDialog: false,
      title: "新建随访",
      listLoading: false,
      symptomRadio: "2",
      medicationBadEventRadio: "2",
      symptomVisiable: false,
      medicationBadEventVisiable: false,
      detail: {
        serviceName: "糖尿病随访",
        content: {
          drinkUnit: "两/天",
          symptoms: [],
          medicines: [
            {
              medicineName: "",
              freq: "",
              dosage: "",
              takeMethod: "",
              remark: ""
            }
          ],
          medicinesGuide: [
            {
              medicineName: "",
              freq: "",
              dosage: "",
              takeMethod: "",
              remark: ""
            }
          ],
          emptyGlu: "",
          twohourGlu: "",
          randomGlu: "",
          nextFollowupTime: ""
        },
      },
    };
  },
  created() {
  },
  methods: {
    // 编辑初始化页面内容
    async init(value) {
      console.log(value);
      var dataContext;
      dataContext = value.data;
      this.detail = value.data;
      this.detail.idcard = dataContext.idcard;
      this.detail.phone = dataContext.phone;
      this.detail.contactName = dataContext.contactName;
      this.detail.contactPhone = dataContext.contactPhone;
      this.detail.healthNo = dataContext.healthNo ? dataContext.healthNo.substr(dataContext.healthNo.length - 8) : "--";
      this.detail.patientName = dataContext.patientName;
      this.detail.address = dataContext.village;
      this.detail.content.emptyGlu = dataContext.content.emptyGlu;
      this.detail.content.twohourGlu = dataContext.content.twohourGlu;
      this.detail.content.randomGlu = dataContext.content.randomGlu;
      this.detail.content.nextFollowupTime = dataContext.content.nextFollowupTime;
      this.showDialog = true;
    },
    // 关闭对话框触发
    setDialogClosed() {
      this.showDialog = false;
    }
  },
};
</script>
<style lang="scss" scoped>
.container {
  height: 500px !important;
  overflow: auto !important;
}

::v-deep {
  .el-dialog {
    margin-top: 5vh !important;
  }
  .el-descriptions-item__label.is-bordered-label {
    width: 92px;
  }
  .el-checkbox-group {
    width: 100px;
  }
}
</style>